import { CloseIcon } from '@assets/icons';
import { Button, IconButton } from '@components/button';
import { ExternalLink } from '@components/link';
import { Modal, useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Box, Container, Modal as MUIModal, Paper, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useCookie } from 'react-use';
import { CookiesCloseModal } from './CookiesCloseModal';
import { CookiesSettingsModal } from './CookiesSettingsModal';

export const CookiesMainBar = () => {
  const { palette } = useTheme();
  const [showCookie, setShowCookie] = useState<boolean>(false);
  const [showForceCookieWindow, setShowForceCookieWindow] = useState<boolean>(false);

  const handleCookieCloseWindow = () => setShowForceCookieWindow(true);

  const [acceptedCookiesCookie, setCookie] = useCookie('deckard');

  const acceptedCookies = acceptedCookiesCookie === 'Agreed';

  const handleAcceptCookie = () => {
    const expireDate = new Date('2200:01:01');
    setCookie('Agreed', {
      path: '/',
      domain: window.location.hostname,
      expires: expireDate,
    });
    setShowCookie(false);
  };
  const { showModal } = useModal({
    component: CookiesSettingsModal,
    componentProps: {
      handleAcceptCookie,
    },
    modalProps: { showClose: true, title: 'Consent to use cookies' },
  });

  const handleAcceptCookieAll = () => {
    setShowForceCookieWindow(false);
    handleAcceptCookie();
  };

  useEffect(() => {
    if (!acceptedCookies) {
      setShowCookie(true);
    } else {
      setShowCookie(false);
    }
  }, [acceptedCookies]);

  return (
    <MUIModal
      open={showCookie}
      sx={{ '&>.MuiBox-root': { backgroundColor: 'transparent', boxShadow: 'none' } }}
      disableAutoFocus
    >
      <Box
        height="80px"
        bottom={0}
        right={0}
        position="fixed"
        width="100%"
        zIndex={1}
        data-cy="Cookies-Main-Bar"
      >
        <Container maxWidth="lg">
          <Paper elevation={12}>
            <Box
              height="80px"
              width="100%"
              bgcolor={palette.background.paper}
              bottom="0"
              display="flex"
              justifyContent="space-between"
            >
              <Box height="100%" display="flex" alignItems="center" pl={10}>
                <Typography variant="body1">
                  We use cookies to analyze our site use and traffic. Click here to learn more about
                  our &quot;
                  <ExternalLink href="https://rendered.ai/privacy-policy/">
                    Privacy policy.
                  </ExternalLink>
                  &quot;
                </Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Box pr={14} display="flex">
                  <Button
                    variant="secondary"
                    data-cy="Cookies-Main-Bar-Cookie-Settings"
                    onClick={() => showModal()}
                  >
                    Cookie settings
                  </Button>
                  <Box pl={5}>
                    <Button
                      variant="primary"
                      data-cy="Cookies-Main-Bar-Accept-All"
                      onClick={handleAcceptCookie}
                    >
                      Accept all
                    </Button>
                  </Box>
                </Box>
                <Box pr={7}>
                  <IconButton
                    onClick={!acceptedCookies && handleCookieCloseWindow}
                    Icon={CloseIcon}
                    data-cy="Cookies-Main-Bar-Close-Icon"
                  />
                </Box>
              </Box>
              <Modal open={showForceCookieWindow}>
                <CookiesCloseModal handleAcceptCookieAll={handleAcceptCookieAll} />
              </Modal>
            </Box>
          </Paper>
        </Container>
      </Box>
    </MUIModal>
  );
};
